var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppliedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.66699C8.65366 2.66699 2.66699 8.65366 2.66699 16.0003C2.66699 23.347 8.65366 29.3337 16.0003 29.3337C23.347 29.3337 29.3337 23.347 29.3337 16.0003C29.3337 8.65366 23.347 2.66699 16.0003 2.66699ZM22.3737 12.9337L14.8137 20.4937C14.627 20.6803 14.3737 20.787 14.107 20.787C13.8403 20.787 13.587 20.6803 13.4003 20.4937L9.62699 16.7203C9.24032 16.3337 9.24032 15.6937 9.62699 15.307C10.0137 14.9203 10.6537 14.9203 11.0403 15.307L14.107 18.3737L20.9603 11.5203C21.347 11.1337 21.987 11.1337 22.3737 11.5203C22.7603 11.907 22.7603 12.5337 22.3737 12.9337Z",
    fill: "#DB4D29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedIcon);
export default __webpack_public_path__ + "static/media/applied-icon.5323dc1fa81024691b408274660882a0.svg";
export { ForwardRef as ReactComponent };